<template>
    <section class="employee-search-container">
        <section-heading step='2' heading='Employee Search'></section-heading>
        <form @submit.prevent>
            <div class="form-container">
                <div class="form-row">
                    <label 
                        class="form-label" 
                        for="first-name">First Name:</label>
                    <input
                        id="first-name"
                        v-model="firstName"
                        type="text"
                        class="form-input form-control"
                        placeholder="First name"/>
                </div>
                <div class="form-row">
                    <label
                        class="form-label"
                        for="last-name">Last Name:</label>
                    <input
                        id="last-name"
                        v-model="lastName"
                        type="text"
                        class="form-input form-control"
                        placeholder="Last name"/>
                </div>
                <div class="form-row">
                    <label
                        class="form-label"
                        for="staff-id">Staff ID:</label>
                    <input
                        id="staff-id"
                        v-model="staffId"
                        type="text"
                        class="form-input form-control"
                        placeholder="Staff ID"/>
                </div>
                <div class="form-row">
                    <label
                        class="form-label"
                        for="date-of-birth">Date of Birth:</label>
                    <date-picker
                        v-model="dateOfBirth"
                        :wrapper-class="'date-input'"
                        :bootstrap-styling="true"
                        :format="dateFormat"
                        placeholder="Date of birth"
                        :clear-button="true"></date-picker>
                </div>
                <div class="buttons-container">
                    <button
                        id="clear-button"
                        :disabled="!validSearch"
                        class="btn btn-outline-danger btn-sm clear-button"
                        type="reset"
                        @click="clearSearch">
                        Clear Search
                    </button>
                    <button
                        id="submit-button"
                        :disabled="isFetchingUsers"
                        class="btn btn-primary submit-button btn-block"
                        type="submit"
                        @click="searchForUser">
                        <template v-if="isFetchingUsers">
                            <span class="spinner-border spinner-border-sm button-spinner" role="status" aria-hidden="true"></span>
                            Loading Users
                        </template>
                        <template v-else>
                        Search
                        </template>
                    </button>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import SectionHeading from './SectionHeading.vue';
export default {
    components: {
        'date-picker': Datepicker,
        'section-heading': SectionHeading,
    },
    props: ['serviceName', 'isFetchingUsers'],
    data() {
        return {
            firstName: '',
            lastName: '',
            staffId: '',
            dateOfBirth: '',
            dateFormat: 'dd/MM/yyyy',
        };
    },
    computed: {
        validSearch() {
            return (
                (!!this.firstName ||
                    !!this.lastName ||
                    !!this.staffId ||
                    !!this.dateOfBirth) &&
                this.serviceName
            );
        },
    },
    methods: {
        searchForUser() {
            if (!this.validSearch) {
                return;
            }

            const searchRequest = {
                firstName: this.firstName || null,
                lastName: this.lastName || null,
                staffId: this.staffId || null,
                dateOfBirth: this.dateOfBirth
                    ? this.$moment(this.dateOfBirth).format('YYYY-MM-DD')
                    : null,
            };

            this.$emit('search', searchRequest);
        },
        clearSearch() {
            this.firstName = '';
            this.lastName = '';
            this.staffId = '';
            this.dateOfBirth = '';
            this.$emit('clearSearch');
        },
    },
};
</script>

<style lang="scss" scoped>
  .employee-search-container {
      margin-bottom: var(--global-gutter-size);
      display: flex;
      flex-direction: column;
      border-radius: var(--global-card-radius);
      .form-container {
          display: flex;
          flex-direction: column;
          .form-row {
              display: flex;
              flex-direction: row;
              align-items: center;
              margin-bottom: 8px;
              .form-label {
                  flex-basis: 120px;
                  margin: 0;
              }
              .form-input,
              .date-input {
                  flex: 1;
              }
          }
          .buttons-container {
              display: flex;
              .submit-button,
              .clear-button {
                  flex: 1;
              }
              .clear-button {
                  margin-right: 8px;
              }
              .submit-button {
                  margin-left: 8px;
              }
          }
      }
  }
  .button-spinner {
      margin-right: 12px;
  }
</style>
